<template>
  <div>
    <van-loading type="spinner" v-if="nodata"/>
    <div style="background: #ffffff;border-bottom: 3px solid #777777;"  v-if="dominItem.templateId === 'temp1'">
      <div class="logo">
        <div style="display: flex; align-items: center; justify-content: space-between; width: 100%">
          <span>{{ dominItem.logoName || 'Logo' }}</span>
          <topIcon :template="dominItem.templateId"  :nationId="dominItem.nationId" color="#ffffff"></topIcon>
        </div>
      </div>
      <div class="category" >
            <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
                item.label
              }}</span>
      </div>
    </div>

    <div style="background: #ffffff;border-bottom: 3px solid #777777;"  v-if="dominItem.templateId === 'temp2'">
      <div class="category" >
            <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
                item.label
              }}</span>
      </div>
      <div class="logo">
        <div style="display: flex; align-items: center; justify-content: space-between; width: 100%">
          <span>{{ dominItem.logoName || 'Logo' }}</span>
          <topIcon :template="dominItem.templateId"  :nationId="dominItem.nationId" color="#ffffff"></topIcon>
        </div>
      </div>

    </div>

    <div style="background: #ffffff;border-bottom: 3px solid #777777;"  v-if="dominItem.templateId === 'temp3'">
      <div class="logo">
        <div style="display: flex; align-items: center; justify-content: space-between; width: 100%">
          <topIcon :template="dominItem.templateId"  :nationId="dominItem.nationId" color="#ffffff"></topIcon>
          <span style="margin-right: 30px">{{ dominItem.logoName || 'Logo' }}</span>

        </div>
      </div>
      <div class="category" >
            <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
                item.label
              }}</span>
      </div>
    </div>



    <div >
      <div class="news-page">
        <!-- 头条轮播区域 -->
        <div style="width: calc(100% - 400px)">
          <div class="top-carousel" @click="toDetail(bestItem.articleShortName)">
            <div class="carousel-container">
              <img :src="bestItem.articleImage" class="carousel-image">
              <div class="carousel-caption">
                <h2 class="carousel-title">{{ bestItem.articleTitle }}</h2>
              </div>
            </div>
          </div>

          <!-- 主要内容区：左侧新闻网格 + 右侧即时新闻 -->
          <div class="main-content">
            <!-- 左侧新闻网格 -->
            <div class="left-content">
              <!-- 第一排三列新闻 -->
              <div class="news-grid three-col">
                <div v-for="(item, index) in articleList" :key="index" class="news-item" @click="toDetail(item.articleShortName)">
                  <div class="news-image-container">
                    <img :src="item.articleImage"  class="news-image">
                  </div>
                  <div class="news-content">
<!--                    <div class="news-time">{{ item.uploadTime }}</div>-->
                    <h3 class="news-title">{{ item.articleTitle }}</h3>
                  </div>
                </div>
              </div>

              <!-- 第二排四列新闻 -->
              <div class="news-grid four-col">
                <div v-for="(item, index) in articleList2" :key="index" class="news-item" @click="toDetail(item.articleShortName)">
                  <div class="news-image-container">
                    <img :src="item.articleImage"  class="news-image">
                  </div>
                  <div class="news-content">
                    <h3 class="news-title">{{ item.articleTitle }}</h3>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
        <div class="right-sidebar">
          <div class="sidebar-header">
            <h3>{{ $t('con_latest') }}</h3>
          </div>
          <ul class="news-list">
            <li v-for="(item, index) in articleList1" :key="index" class="news-item" @click="toDetail(item.articleShortName)">
<!--              <div class="news-time">{{ item.uploadTime }}</div>-->
              <div class="news-title">{{ item.articleTitle }}</div>
            </li>
          </ul>
        </div>          <!-- 右侧即时新闻 -->

      </div>

      <div class="but-box">
        <div class="channels-container">
          <!-- 自由藝文频道 -->
          <div class="channel-item">
            <div class="channel-header">
              <h3 class="channel-title">{{ $t('con_hot_con') }}</h3>
              <span class="channel-arrow"></span>
            </div>
            <div class="channel-content">
              <div class="featured-image" @click="toDetail(item.articleShortName)"
                   v-for="item in articleList3.slice(0, 2)">
                <img :src="item?.articleImage" class="channel-image">
                <p class="image-caption">{{
                    item?.articleTitle
                  }}</p>
              </div>
              <ul class="news-list">
                <li class="news-item-small" v-for="item in articleList3.slice(3, 12)"  @click="toDetail(item.articleShortName)">
                  {{ item.articleTitle }}</li>
              </ul>
            </div>
          </div>

          <!-- 軍武频道 -->
          <div class="channel-item">
            <div class="channel-header">
              <h3 class="channel-title">{{ $t('con_bestnew') }}</h3>
              <span class="channel-arrow"></span>
            </div>
            <div class="channel-content">
              <div class="featured-image"  @click="toDetail(item.articleShortName)" v-for="item in articleList4.slice(0, 2)">
                <img :src="item?.articleImage" class="channel-image">
                <p class="image-caption">{{
                    item?.articleTitle
                  }}</p>
              </div>
              <ul class="news-list">
                <li class="news-item-small" v-for="item in articleList4.slice(3, 12)"  @click="toDetail(item.articleShortName)">
                  {{ item.articleTitle }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="buttom" style="margin-top: 20px">
      <div class="explore">
        <span style="color: #111111">{{ $t('con_Explore') }}</span>
        <span v-for="item in typeList" @click="changeType(item.id)" style="cursor: pointer; color: #000000">{{ item.label }}</span>
      </div>
      <div class="logo" style="color: #000000;">{{ dominItem.logoName || 'Logo' }}</div>
      <footers is00="is00" :articleListlast="articleListlast" :current="current"></footers>
    </div>
  </div>
</template>

<script>
import {getOne, newContent} from "@/api"
import topIcon from '../../icons/iconblick.vue'
import {format} from "date-fns";
import buttomIcon from '../../icons/big.vue'
import footers from "@/components/footContent/index.vue"

export default {
  components: {topIcon, buttomIcon, footers},


  props: {
    dominItem: Object
  },

  name: "index",
  data() {
    return {
      bestItem: {},
      nodata: false,
      // template: 'temp3',
      current: 1,
      recommendList: [],
      latestNewsList: [],
      articleList: [],
      articleList1: [],
      articleList2: [],
      articleList3: [],
      articleList4: [],
      articleListlast: [],
      recommendList1: [],
      typeList: [
        {label: this.$t('con_AllPRESS'), id: 4},
        {label: this.$t('con_home'), id: 1},
        {label: this.$t('con_AUTO'), id: 6},
        {label: this.$t('con_NEWS'), id: 3},
        {label: this.$t('con_BUSINESS'), id: 2},
        {label: this.$t('con_TECHNOLOGY'), id: 7},
        {label: this.$t('con_LIFESTYLE'), id: 5},
      ],
      iconListsmall: [
        {url: require('../../../assets/icon/linkedin.png'), link: 'https://www.linkedin.cn/'},
        {url: require('../../../assets/icon/facebook.png'), link: 'https://www.facebook.com/'},
        {url: require('../../../assets/icon/flipboard.png'), link: 'https://www.flipboard.cn/'},
        {url: require('../../../assets/icon/twitter.png'), link: 'https://twitter.com/'},
        {url: require('../../../assets/icon/instagram.png'), link: 'https://www.instagram.com/'},
      ],
    }
  },
  created() {
    this.nationId = JSON.parse(localStorage.getItem('dominItem')).nationId


    if (this.$route.query.type) {
      this.changeType(Number(this.$route.query.type))
    } else {
      this.getArticleList()
      this.getArticleListlast()
      this.getLatestNewsList()
      this.getRecommendList()
      this.getRecommendList1()
      this.getRecommendList2()
      this.getOneList()
    }
  },

  methods: {
    openLink(link) {
      window.open(link)
    },
    changeType(item) {
      if (item === 8) {
        item = 1
      }
      this.nodata = true
      this.current = item
      this.getArticleList()
      this.getArticleListlast()
      this.getLatestNewsList()
      this.getRecommendList()
      this.getRecommendList1()
      this.getRecommendList2()
      this.getOneList()
    },

    // 获取最新的一篇文章
    getOneList() {
      getOne({articleCategoryId: this.current, articleNationId: this.dominItem.nationId}).then(res => {
        if (!res.data.articleImage) {
          res.data.articleImage = require('@/assets/defore.jpg')
        }
        this.bestItem = res.data
        this.bestInfo.uploadTime = format(new Date(this.bestInfo.uploadTime), this.$t('con_format'))
      })
    },


    // 获取推荐文章列表
    getArticleList() {
      newContent({
        articleCategoryId: this.current,
        pageNum: this.newsPageNum,
        pageSize: 3,
        articleNationId: this.nationId,
        articleType: 'con_recommended'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList = res.rows
        this.nodata = false
      })
    },


    // 获取最新文章
    getLatestNewsList() {
      newContent({
        articleCategoryId: this.current,
        pageNum: this.newsPageNum,
        pageSize: 10,
        articleNationId: this.nationId,
        articleType: 'con_latest'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList1 = res.rows
        this.newsTotal = res.total
      })
    },

    //  获取热门文章
    getRecommendList() {
      newContent({
        articleCategoryId: this.current, pageNum: this.recommendPageNum, pageSize: 4,

        articleNationId: this.nationId, articleType: 'con_hot_con'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList2 = res.rows
      })
    },

    // 获取最新推荐
    getRecommendList1() {
      newContent({
        articleCategoryId: this.current,
        pageNum: 1,
        pageSize: 12,
        articleNationId: this.nationId,
        articleType: 'con_bestnew'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList3 = res.rows
      })
    },

    // 获取最新推荐
    getRecommendList2() {
      newContent({
        articleCategoryId: this.current,
        pageNum: 1,
        pageSize: 9,
        articleNationId: this.nationId,
        articleType: 'con_bestnew'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList4 = res.rows
      })
    },

    // 获取最下面文章列表  相关文章
    getArticleListlast() {
      // this.nodata = true
      newContent({
        articleCategoryId: this.current,
        pageNum: 3,
        pageSize: 6,
        articleNationId: this.nationId,
        articleType: 'con_related'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleListlast = res.rows
        this.nodata = false
      })
    },

    //  查看详情
    toDetail(name) {
      this.$router.push(`/details/${name}?type=${this.current}`)
    }
  }
};
</script>

<style scoped lang="scss">
.but-box {
  .channels-container {
    display: flex;
    justify-content: space-between;
    padding: 0 10%;
    gap: 20px;
  }

  .channel-item {
    flex: 1;
    border: 1px solid #E6E8EA;
    border-radius: 8px;
    overflow: hidden;
    background-color: white;
  }

  .channel-header {
    color: #333333;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
  }

  .channel-title {
    font-size: 25px;
    font-weight: bold;
    margin: 0;
  }

  .channel-arrow {
    width: 0;
    height: 0;
    border-left: 10px solid white;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
  }

  .channel-content {
    padding: 0 20px 20px;
  }

  .featured-image {
    margin-bottom: 20px;
  }

  .channel-image {
    width: 100%;
    height: 300px;
    object-fit: cover;
    border-radius: 4px;
  }

  .image-caption {
    font-size: 18px;
    font-weight: bold;
    margin-top: 10px;
    color: #333333;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .image-caption:hover {
    cursor: pointer;
    color: #C60000;
  }

  .news-list {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }

  .news-item-small {
    padding: 10px 0;
    border-bottom: 1px solid #E6E8EA;
    font-size: 16px;
    color: #666666;
    cursor: pointer;
    position: relative;
    padding-left: 15px;
  }

  .news-item-small:before {
    content: "";
    color: #05B2FC;
    width: 3px;
    height: 20px;
    background: #E8AE2B;
    position: absolute;
    left: 0;
    font-size: 8px;
  }

  .news-item-small:hover {
    color: #C60000;
  }

  .news-item-small:last-child {
    border-bottom: none;
  }
}


.news-page {
  padding: 20px 10%;
  display: flex;
  gap: 20px;
}

/* 轮播图样式 */
.top-carousel {
  width: 100%;
  margin: 0 auto 30px;
  overflow: hidden;
  position: relative;
}

.carousel-container {
  position: relative;
}

.carousel-image {
  width: 100%;
  height: 400px;
  object-fit: cover;
}

.carousel-caption {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
  padding: 20px;
  color: white;
}

.carousel-title {
  font-size: 24px;
  margin: 0;
}

.carousel-navigation {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
}

.carousel-btn {
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.carousel-dots {
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  gap: 8px;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  cursor: pointer;
}

.dot.active {
  background: white;
}

/* 主要内容区 */
.main-content {
  display: flex;
  width: 100%;
  margin: 0 auto;
  gap: 20px;
}

.left-content {
  flex: 3;
}

.right-sidebar {
  width: 400px;
  background: #f5f5f5;
  padding: 15px;
  border-radius: 5px;
}

/* 新闻网格 */
.news-grid {
  display: grid;
  gap: 20px;
  margin-bottom: 30px;
}

.three-col {
  grid-template-columns: repeat(3, 1fr);
}

.four-col {
  grid-template-columns: repeat(4, 1fr);
}

.news-item {
  cursor: pointer;
  transition: transform 0.2s ease;
}

.news-item:hover {
  transform: translateY(-3px);
}

.news-image-container {
  width: 100%;
  height: 180px;
  overflow: hidden;
}

.news-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.news-item:hover .news-image {
  transform: scale(1.05);
}

.news-content {
  padding: 10px 0;
}

.news-time {
  font-size: 12px;
  color: #999;
  margin-bottom: 5px;
}

.news-title {
  font-size: 16px;
  font-weight: bold;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* 右侧即时新闻 */
.sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e2001a;
}

.sidebar-header h3 {
  margin: 0;
  font-size: 18px;
  color: #e2001a;
}

.more-link {
  color: #666;
  text-decoration: none;
  font-size: 14px;
}

.news-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.news-list .news-item {
  padding: 12px 0;
  border-bottom: 1px dashed #ddd;
  display: flex;
  flex-direction: column;
}

.news-list .news-title {
  font-size: 14px;
  font-weight: normal;
}

.news-indicator {
  width: 8px;
  height: 8px;
  background: #e2001a;
  border-radius: 50%;
  margin-top: 5px;
}

.but-box {
}


.logo {
  width: 85%;
  margin-left: 15%;
  padding: 10px 0;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  font-size: 25px;
  color: #A57125;
  justify-content: space-between;
  font-weight: bold;
  text-align: left;
}

.logo-temp1 {
  padding: 0 20px 0 15%;
}

.logo-temp2 {
}

.category {
  width: 70%;
  margin: 0 auto;
  min-height: 40px;
  //margin-bottom: 30px;
  color: #111111;
  font-weight: 700;
  //border-top: 2px solid var(--themeColor);
  //border-bottom: 2px solid #E6E8EA;
  line-height: 38px;

  span {
    font-weight: 500;
    font-size: 18px;
    display: inline-block;
    padding: 0 10px;
    cursor: pointer;
    position: relative;
    //border-bottom: 3px solid #ffffff;
  }

  span:hover {
    color: red;
    //border-bottom: 3px solid red;
    transition: all .1s ease;
  }

  .choose {
    transition: all .1s ease;
    color: red;
    //border-bottom: 3px solid #000000;
  }
}

.buttom {
  background: #ffffff;
  border-top: 2px solid #000000;
  display: flex;
  flex-direction: column;

  .logo {
    width: 80%;
    margin: auto;
    font-size: 20px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    text-align: center !important;
  }

  display: flex;

  .explore {
    display: flex;
    justify-content: center;
    margin-top: 30px;
    align-items: center;

    span:first-child {
      color: #004F8B;
      font-size: 18px;
      font-weight: bold;
      margin-right: 30px;
    }

    span {
      margin-right: 10px;
      font-size: 15px;
    }
  }
}

.about {
  cursor: pointer;
  height: 40px;
  line-height: 40px;
  font-weight: 400;
  font-size: 17px;
  text-transform: uppercase;
  display: flex;
  justify-content: end;
  //justify-content: space-between;
  padding-right: 20px;
  color: #000000;
  align-items: center;

  span {
    margin-left: 20px;
    margin-right: 20px;
  }

  img {
    width: 20px;
    height: 20px;
  }

  img:nth-child(4) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(5) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(6) {
    width: 30px;
    height: 30px;
  }
}


.content {
  display: flex;
  flex-wrap: wrap;

  span {
    display: inline-block;
    margin-bottom: 10px;
    width: 50%;
  }
}

.imgsss {
  width: 30px;
  height: 30px;
}

.imgsss:nth-child(4) {
  width: 40px;
  height: 40px;
}

.imgsss:nth-child(5) {
  width: 40px;
  height: 40px;
}

.imgsss:nth-child(3) {
  width: 40px;
  height: 40px;
}

.article-image1 {
  width: 80px;
  height: 80px;
  object-fit: cover;
}

.bgSpan {
  color: #ffffff;
  border-radius: 5px;
  border: 1px solid red;
  display: inline-block;
  padding: 5px 10px;
  background: #E2001A;
}

</style>